// TODO: change "/assets" to "/fe-assets"
export enum ViewImage {
  // edit contract
  EditContractBg = '/assets/views/editContract/bg.jpg',
  EditContractMobileBg = '/assets/views/editContract/mobileBg.jpg',
  // contract summary
  ContractSummaryBigLinesShape = '/assets/views/contractSummary/bigLinesShape.svg',
  ContractSummaryCarImage = '/assets/views/contractSummary/car.png',
  ContractSummaryCircleImage = '/assets/views/contractSummary/circle.svg',
  ContractSummaryLinesShape = '/assets/views/contractSummary/linesShape.svg',
  ContractSummaryStar = '/assets/views/contractSummary/star.svg',
  ContractSummaryPdfIcon = '/assets/common/filesExtCovers/pdfTile.svg',
  // common
  CommonHelpBannerBg = '/assets/common/helpBannerBg/desktop.jpg',
  CommonHelpBannerMobileBg = '/assets/common/helpBannerBg/mobile.jpg',
  CommonLogoLight = '/assets/common/logos/light.svg',
  CommonLogoDark = '/assets/common/logos/dark.svg',
  CommonICLogoWartaDark = '/assets/common/insuranceCompanyLogos/wartaDark.svg',
  CommonICLogoCompensaDark = '/assets/common/insuranceCompanyLogos/compensaDark.svg',
  CommonICLogoAllianzDark = '/assets/common/insuranceCompanyLogos/allianzDark.svg',
  CommonICLogoCardifDark = '/assets/common/insuranceCompanyLogos/cardifDark.svg',
  CommonICLogoHestiaDark = '/assets/common/insuranceCompanyLogos/hestiaDark.svg',
  CommonICLogoPzuDark = '/assets/common/insuranceCompanyLogos/pzuDark.svg',
  CommonICLogoWartaOutlined = '/assets/common/insuranceCompanyLogos/wartaOutlined.svg',
  CommonICLogoCompensaOutlined = '/assets/common/insuranceCompanyLogos/compensaOutlined.svg',
  CommonICLogoAllianzOutlined = '/assets/common/insuranceCompanyLogos/allianzOutlined.svg',
  CommonICLogoCardifOutlined = '/assets/common/insuranceCompanyLogos/cardifOutlined.svg',
  CommonICLogoHestiaOutlined = '/assets/common/insuranceCompanyLogos/hestiaOutlined.svg',
  CommonICLogoPzuOutlined = '/assets/common/insuranceCompanyLogos/pzuOutlined.svg',
  CommonICLogoAxaOutlined = '/assets/common/insuranceCompanyLogos/axaOutlined.svg',
  CommonICLogoAxaDark = '/assets/common/insuranceCompanyLogos/axaDark.svg',
  CommonICLogoHelvetiaOutlined = '/assets/common/insuranceCompanyLogos/helvetiaOutlined.svg',
  CommonICLogoHelvetiaDark = '/assets/common/insuranceCompanyLogos/helvetiaDark.svg',
  CommonICLogoWartaLight = '/assets/common/insuranceCompanyLogos/wartaLight.svg',
  CommonICLogoAllianzLight = '/assets/common/insuranceCompanyLogos/allianzLight.svg',
  CommonICLogoAxaLight = '/assets/common/insuranceCompanyLogos/axaLight.svg',
  CommonICLogoCardifLight = '/assets/common/insuranceCompanyLogos/cardifLight.svg',
  CommonICLogoCompensaLight = '/assets/common/insuranceCompanyLogos/compensaLight.png',
  CommonICLogoHelvetiaLight = '/assets/common/insuranceCompanyLogos/helvetiaLight.svg',
  CommonICLogoHestiaLight = '/assets/common/insuranceCompanyLogos/hestiaLight.png',
  CommonICLogoPzuLight = '/assets/common/insuranceCompanyLogos/pzuLight.svg',
  // common - file tiles
  PdfTile = '/assets/common/fileTypes/pdfTile.svg',
  DocTile = '/assets/common/fileTypes/docTile.svg',
  JpgTile = '/assets/common/fileTypes/jpgTile.svg',
  XlsTile = '/assets/common/fileTypes/xlsTile.svg',
  XmlTile = '/assets/common/fileTypes/xmlTile.svg',
  PptTile = '/assets/common/fileTypes/pptTile.svg',
  PngTile = '/assets/common/fileTypes/pngTile.svg',
  XadesTile = '/assets/common/fileTypes/xadesTile.svg',
  File = '/assets/common/fileTypes/file.svg',
  // common - file covers
  PdfCover = '/assets/common/fileTypes/pdfCover.svg',
  DocCover = '/assets/common/fileTypes/docCover.svg',
  JpgCover = '/assets/common/fileTypes/jpgCover.svg',
  XlsCover = '/assets/common/fileTypes/xlsCover.svg',
  PptCover = '/assets/common/fileTypes/pptCover.svg',
  PngCover = '/assets/common/fileTypes/pngCover.svg',
  // img
  SearchPopupNewsDefaultImage = '/assets/img/searchPopupNewsDefaultCover.png',
  TrainingsDefaultThumbnail = '/assets/img/defaultThumbnail.png',
  // test and forms
  TestAndFormsBottomShape = '/assets/views/testsAndForms/bottomShape.svg',
  TestAndFormsBottomShapeMobile = '/assets/views/testsAndForms/bottomShape.mobile.svg',
  TestAndFormsShape = '/assets/views/testsAndForms/shape.svg',
  TestAndFormsCarIcon = '/assets/views/testsAndForms/carIcon.svg',
  TestAndFormsKeyboard = '/assets/views/testsAndForms/keyboardIcon.svg',
  TestAndFormsMainBg = '/assets/views/testsAndForms/car.desktop.jpg',
  TestAndFormsMainBgMobile = '/assets/views/testsAndForms/car.mobile.jpg',
  // users administration - companiesList
  BannerImage = '/assets/views/usersAdministration/companiesList/banner.png',
  BottomShape = '/assets/views/usersAdministration/companiesList/bottomShape.svg',
  // users administration - user details
  UserDetailsMobileBackground = '/assets/views/usersAdministration/userDetails/mobileBg.png',
  UserDetailsBackgroundShape = '/assets/views/usersAdministration/userDetails/bgShape.svg',
  // users administration - courses
  AdministrationCoursesBannerDesktop = '/assets/views/usersAdministration/courses/bannerDesktop.png',
  AdministrationCoursesBannerMobile = '/assets/views/usersAdministration/courses/bannerMobile.png',
  AdministrationCoursesBottomShape = '/assets/views/usersAdministration/courses/bottomShape.svg',
  // users administration - company dashboard
  CompanyDashboardBarShapeMobile = '/assets/views/usersAdministration/companyDashboard/shapeMobile.svg',
  CompanyDashboardBarShape = '/assets/views/usersAdministration/companyDashboard/shape.svg',
  CompanyDashboardCar = '/assets/views/usersAdministration/companyDashboard/car.png',
  CompanyDashboardBottomShape = '/assets/views/usersAdministration/companyDashboard/bottomShape.svg',
  CompanyDashboardBottomShapeMobile = '/assets/views/usersAdministration/companyDashboard/bottomShapeMobile.svg',
  CompanyDashboardPopupShape = '/assets/views/usersAdministration/companyDashboard/popupShape.svg',
  CompanyDashboardPopupShapeMobile = '/assets/views/usersAdministration/companyDashboard/popupShapeMobile.svg',
  // users administration - cyclical lessons
  CyclicalLessonsBottomShape = '/assets/views/usersAdministration/cyclicalLessons/bottomShape.svg',
  CyclicalLessonsBannerDesktop = '/assets/views/usersAdministration/cyclicalLessons/bannerDesktop.png',
  CyclicalLessonsBannerMobile = '/assets/views/usersAdministration/cyclicalLessons/bannerMobile.png',
  // users administration - dashboard
  AdministrationDashboardCar = '/assets/views/usersAdministration/dashboard/car.png',
  AdministrationDashboardShapeMobile = '/assets/views/usersAdministration/dashboard/shapeMobile.svg',
  AdministrationDashboardShape = '/assets/views/usersAdministration/dashboard/shape.svg',
  AdministrationDashboardBottomShape = '/assets/views/usersAdministration/dashboard/bottomShape.svg',
  AdministrationDashboardBottomShapeMobile = '/assets/views/usersAdministration/dashboard/bottomShapeMobile.svg',
  // actionRequiredToAccessPlatform
  ActionRequiredToAccessPlatformDefaultBg = '/assets/views/actionRequiredToAccessPlatform/bg.jpg',
  ActionRequiredToAccessPlatformKrkColumnImg = '/assets/views/actionRequiredToAccessPlatform/krkColumnImg.jpg',
  ActionRequiredToAccessPlatformKrkColumnImgMobile = '/assets/views/actionRequiredToAccessPlatform/krkColumnImgMobile.jpg',
  // users administration - users pending offboarding list
  UsersPendingOffboardingListBanner = '/assets/views/usersAdministration/usersPendingOffboardingList/banner.png',
  // dashboard
  DashboardV2EventCardBackground = '/assets/views/dashboardV2/eventCardDefault.png',
  DashboardV2BgImage = '/assets/views/dashboardV2/bg.png',
  // training
  TrainingV2RaysShape = '/assets/views/trainingV2/rays.svg',
  TrainingV2DefaultBanner = '/assets/views/trainingV2/defaultBanner.png',
  TrainingV2Blocks = '/assets/views/trainingV2/blocks.svg',
  // provisions common
  ProvisionsBarShape = '/assets/views/provisions/common/shape.svg',
  ProvisionsBarShapeMobile = '/assets/views/provisions/common/shapeMobile.svg',
  // provisions - complaint details
  ProvisionsComplaintDetailsMobileBg = '/assets/views/provisions/complaintDetails/mobileBg.jpg',
  // provisions - complaints list
  ProvisionsComplaintListBannerImage = '/assets/views/provisions/userComplaintList/banner.png',
  // provisions - sheets and complaints list
  ProvisionsSheetsAndComplaintsListBannerImage = '/assets/views/provisions/sheetsAndComplaintsList/banner.png',
  ProvisionsSheetsAndComplaintsListShape = '/assets/views/provisions/sheetsAndComplaintsList/shape.svg',
  ProvisionsSheetsAndComplaintsListShapeMobile = '/assets/views/provisions/sheetsAndComplaintsList/shapeMobile.svg',
  // anon survey
  AnonSurvey01 = '/assets/views/anonSurveys/01.jpg',
  AnonSurvey01Mobile = '/assets/views/anonSurveys/01_mobile.jpg',
  AnonSurvey02 = '/assets/views/anonSurveys/02.jpg',
  AnonSurvey02Mobile = '/assets/views/anonSurveys/02_mobile.jpg',
  AnonSurvey03 = '/assets/views/anonSurveys/03.jpg',
  AnonSurvey03Mobile = '/assets/views/anonSurveys/03_mobile.jpg',
  AnonSurvey04 = '/assets/views/anonSurveys/04.jpg',
  AnonSurvey04Mobile = '/assets/views/anonSurveys/04_mobile.jpg',
  AnonSurvey05 = '/assets/views/anonSurveys/05.jpg',
  AnonSurvey05Mobile = '/assets/views/anonSurveys/05_mobile.jpg',
  AnonSurvey06 = '/assets/views/anonSurveys/06.jpg',
  AnonSurvey06Mobile = '/assets/views/anonSurveys/06_mobile.jpg',
  AnonSurvey07 = '/assets/views/anonSurveys/07.jpg',
  AnonSurvey07Mobile = '/assets/views/anonSurveys/07_mobile.jpg',
  AnonSurvey08 = '/assets/views/anonSurveys/08.jpg',
  AnonSurvey08Mobile = '/assets/views/anonSurveys/08_mobile.jpg',
  AnonSurvey09 = '/assets/views/anonSurveys/09.jpg',
  AnonSurvey09Mobile = '/assets/views/anonSurveys/09_mobile.jpg',
  AnonSurvey10 = '/assets/views/anonSurveys/10.jpg',
  AnonSurvey10Mobile = '/assets/views/anonSurveys/10_mobile.jpg',
  AnonSurvey11 = '/assets/views/anonSurveys/11.jpg',
  AnonSurvey11Mobile = '/assets/views/anonSurveys/11_mobile.jpg',
  AnonSurvey12 = '/assets/views/anonSurveys/12.jpg',
  AnonSurvey12Mobile = '/assets/views/anonSurveys/12_mobile.jpg',
  AnonSurvey13 = '/assets/views/anonSurveys/13.jpg',
  AnonSurvey13Mobile = '/assets/views/anonSurveys/13_mobile.jpg',
  AnonSurvey14 = '/assets/views/anonSurveys/14.jpg',
  AnonSurvey14Mobile = '/assets/views/anonSurveys/14_mobile.jpg',
  AnonSurvey15 = '/assets/views/anonSurveys/15.jpg',
  AnonSurvey15Mobile = '/assets/views/anonSurveys/15_mobile.jpg',
  AnonSurvey16 = '/assets/views/anonSurveys/16.jpg',
  AnonSurvey16Mobile = '/assets/views/anonSurveys/16_mobile.jpg',
    // provisions - dashboards
  ProvisionsDashboardsStatisticsReportBg = '/assets/views/provisions/dashboards/statisticsReportsBg.jpg',
  // provisions - user dashboard
  ProvisionsUserDashboardBottomShape = '/assets/views/provisions/userDashboard/bottomShape.svg',
  ProvisionsUserDashboardLeftShape = '/assets/views/provisions/userDashboard/leftShape.svg',
  ProvisionsUserDashboardRightShape = '/assets/views/provisions/userDashboard/rightShape.svg',
  // provisions - admin dashboard
  ProvisionsAdminDashboardLeftShape = '/assets/views/provisions/adminDashboard/leftShape.svg',
  ProvisionsAdminDashboardRightShape = '/assets/views/provisions/adminDashboard/rightShape.svg',
  ProvisionsAdminDashboardBottomShape = '/assets/views/provisions/adminDashboard/bottomShape.svg',
  // provisions - administrator dashboard
  ProvisionsAdministratorDashboardCarShape = '/assets/views/provisions/administratorDashboard/shapeCar.svg',
  // provisions- user month sheets
  ProvisionsUserMonthSheetsReportBg = '/assets/views/provisions/userMonthSheets/statisticsReportsBg.jpg',
  ProvisionsUserMonthSheetsBannerImage = '/assets/views/provisions/userMonthSheets/banner.png',
  // provisions- sheet details
  ProvisionsSheetDetailsMobileBg = '/assets/views/provisions/sheetDetails/mobileBg.jpg',
  // substitutions - create
  SubstitutionCreateBgDesktop = '/assets/views/substitutions/bgDesktop.jpg',
  SubstitutionCreateBgMobile = '/assets/views/substitutions/bgMobile.jpg',
  // substitutions - dashboard
  SubstitutionsDashboardBannerDesktop = '/assets/views/substitutions/dashboard/bannerDesktop.jpg',
  SubstitutionsDashboardBannerMobile = '/assets/views/substitutions/dashboard/bannerMobile.jpg',
  SubstitutionsDashboardBars = '/assets/views/substitutions/dashboard/bars.svg',
  SubstitutionsDashboardRays = '/assets/views/substitutions/dashboard/rays.svg',
    // substitutions - list
  SubstitutionsListBannerDesktop = '/assets/views/substitutions/list/bannerDesktop.png',
  SubstitutionsListBannerMobile = '/assets/views/substitutions/list/bannerMobile.png',
  SubstitutionsListFrame = '/assets/views/substitutions/list/frame.svg',
  // userProfile
  UserProfileAvatarPopupRedShape = '/assets/views/userProfile/avatarPopupRedShape.svg',
  UserProfileAvatarPopupGrayShape = '/assets/views/userProfile/avatarPopupGrayShape.svg',
  // legal forms
  LegalFormsCar = '/assets/views/legalForms/car.png',
  LegalFormsDocumentsIcon = '/assets/views/legalForms/documents.svg',
  LegalFormsPassportExample = '/assets/views/legalForms/passportExample.jpg',
  LegalFormsHeaderImage = '/assets/views/legalForms/headerImage.svg',
  LegalFormsHeaderMobileImage = '/assets/views/legalForms/headerMobileImage.svg',
  // reports - dashboard
  ReportsDashboardBottomShape = '/assets/views/reports/reportsDashboard/bottomShape.svg',
  // reports - report
  ReportsReportBg = '/assets/views/reports/report/bg.jpg',
  ReportsReportBgMobile = '/assets/views/reports/report/mobileBg.jpg',
  // pathRequests - required content list
  PathRequestsRequiredContentListBottomShape = '/assets/views/pathRequests/pathRequestRequiredContentList/bottomShape.svg',
  PathRequestsRequiredContentListDecoration = '/assets/views/pathRequests/pathRequestRequiredContentList/decoration.svg',
  // pathRequests - list
  PathRequestsListSettings = '/assets/views/pathRequests/pathRequestsList/settings.svg',
  PathRequestsListBottomShape = '/assets/views/pathRequests/pathRequestsList/bottomShape.svg',
  PathRequestsListBottomShapeMobile = '/assets/views/pathRequests/pathRequestsList/bottomShapeMobile.svg',
  // pathRequests - user list
  UserPathRequestsListEducationVerificationBgLarge = '/assets/views/pathRequests/userPathRequests/educationVerification/bgLarge.jpg',
  UserPathRequestsListEducationVerificationBgSmall = '/assets/views/pathRequests/userPathRequests/educationVerification/bgSmall.jpg',
  // pathRequests - details
  PathRequestDocsIcon = '/assets/views/pathRequests/pathRequest/docsIcon.svg',
  // pathRequests - exams to process list
  PathRequestsExamsToProcessListBars = '/assets/views/pathRequests/pathRequestsExamsToProcessList/bars.svg',
  PathRequestsExamsToProcessListBottomShape = '/assets/views/pathRequests/pathRequestsExamsToProcessList/bottomShape.svg',
  PathRequestsExamsToProcessListBottomShapeMobile = '/assets/views/pathRequests/pathRequestsExamsToProcessList/bottomShapeMobile.svg',
  PathRequestsExamsToProcessListBarsMobile = '/assets/views/pathRequests/pathRequestsExamsToProcessList/barsMobile.svg',
  // pathRequests - history
  PathRequestHistoryBars = '/assets/views/pathRequests/pathRequestHistory/bars.svg',
  PathRequestHistoryBarsMobile = '/assets/views/pathRequests/pathRequestHistory/barsMobile.svg',
  PathRequestHistoryBottomShape = '/assets/views/pathRequests/pathRequestHistory/bottomShape.svg',
  PathRequestHistoryBottomShapeMobile = '/assets/views/pathRequests/pathRequestHistory/bottomShapeMobile.svg',
  PathRequestHistoryFrames = '/assets/views/pathRequests/pathRequestHistory/frames.svg',
  // pathRequests - documents upload
  PathRequestDocumentsUploadFiles = '/assets/views/pathRequests/pathRequestDocumentsUpload/files.svg',
  // pathRequests - paper documents verification
  PathRequestPaperDocumentsVerificationFrames = '/assets/views/pathRequests/pathRequestPaperDocumentsVerification/frames.svg',
  // pathRequests - user paper documents
  UserPathRequestPaperDocumentsFrames = '/assets/views/pathRequests/userPathRequestPaperDocumentsList/frames.svg',
  // pathRequests - path request documents upload verification
  PathRequestDocumentsUploadVerificationBg = '/assets/views/pathRequests/pathRequestDocumentsUploadVerification/bg.jpg'
}
